module.exports = __webpack_public_path__ + "img/mutai_content_three.3c6d4444.png";